module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-pinterest-1-94b8de511d399df55314b7dd97ec0041.jpg";